// extracted by mini-css-extract-plugin
export default {"tableRow":"roleList_tableRow__hFS8p","tableCell":"roleList_tableCell__Tpt+2"};